import {
  IPlayerNote,
  INoteTopic,
  ICreateNote,
  IEditNote,
  IPlayerOffer,
  IPlayerSearchInfo,
  IBasicPlayerInformation,
  IPlayerInformation,
  IPlayerStatus,
  IPlayerLanguage,
  IUpdatePlayerLanguage,
} from "services/models";
import { getRandom, getRandomArray, getRandomDate, getRandomInt, mockNetRevenue } from "./data";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import { faker } from "@faker-js/faker/locale/en_US";
import { IPlayerFolio } from "services/models/Player/PlayerFolio";
import { getDateAfter } from "utils";
import { Buffer } from "buffer";
import { tiers } from "./host-data";
import {
  IBuildUpPlayer,
  IBuildUpStatus,
  IBuildUpStatusUpdate,
  IFreePlayStats,
  ICurrentBuildUpStatus,
} from "services/models/BuildUpPlayer";

const topicIds = new Array(50).fill(1).map((value, index) => index + 1);

const offerCategories = [
  { id: 1, name: "Slots" },
  { id: 2, name: "Dining" },
];

const mockPlayers: IPlayerSearchInfo[] = [
  {
    playerId: 2728215,
    firstName: "Nicholas",
    lastName: "Mata",
    preferredName: "Nick",
    hostName: "Mike Herandez",
    currentTier: tiers[1].name,
    currentTierColor: tiers[1].color,
    email: {
      value: "nicholas.mata@email.com",
      isValid: true,
      marketingOptOut: true,
    },
    phone: {
      value: faker.phone.number(),
      isValid: true,
      marketingOptOut: false,
    },
  },
  {
    playerId: 2728216,
    firstName: "Baoquan",
    lastName: "Dinh",
    preferredName: "BQ",
    hostName: "Mike Herandez",
    currentTier: tiers[2].name,
    currentTierColor: tiers[2].color,
    email: {
      value: "baoquan.dinh@email.com",
      isValid: true,
      marketingOptOut: false,
    },
    phone: {
      value: faker.phone.number(),
      isValid: true,
      marketingOptOut: true,
    },
  },
  {
    playerId: 2728217,
    firstName: "John",
    lastName: "Huynh",
    preferredName: "Johnny",
    hostName: "Mike Herandez",
    currentTier: tiers[3].name,
    currentTierColor: tiers[3].color,
    email: {
      value: "john.huynh@email.com",
      isValid: true,
      marketingOptOut: false,
    },
    phone: {
      value: faker.phone.number(),
      isValid: true,
      marketingOptOut: false,
    },
  },
  {
    playerId: 2728219,
    firstName: "Linda",
    lastName: "Lee",
    preferredName: "London",
    hostName: "Mike Herandez",
    currentTier: tiers[3].name,
    currentTierColor: tiers[3].color,
    email: {
      value: "lee.linda@email.com",
      isValid: true,
      marketingOptOut: false,
    },
    phone: {
      value: faker.phone.number(),
      isValid: true,
      marketingOptOut: false,
    },
  },
  {
    playerId: getRandomInt(100000, 300000),
    firstName: faker.person.firstName(),
    lastName: faker.person.lastName(),
    preferredName: faker.person.firstName(),
    hostName: faker.person.fullName(),
    currentTier: tiers[3].name,
    currentTierColor: tiers[3].color,
    email: {
      value: "lee.linda@email.com",
      isValid: true,
      marketingOptOut: false,
    },
    phone: {
      value: faker.phone.number(),
      isValid: true,
      marketingOptOut: false,
    },
  },
  {
    playerId: getRandomInt(100000, 300000),
    firstName: faker.person.firstName(),
    lastName: faker.person.lastName(),
    preferredName: faker.person.firstName(),
    hostName: faker.person.fullName(),
    currentTier: tiers[3].name,
    currentTierColor: tiers[3].color,
    email: {
      value: "lee.linda@email.com",
      isValid: true,
      marketingOptOut: false,
    },
    phone: {
      value: faker.phone.number(),
      isValid: true,
      marketingOptOut: false,
    },
  },
  {
    playerId: getRandomInt(100000, 300000),
    firstName: faker.person.firstName(),
    lastName: faker.person.lastName(),
    preferredName: faker.person.firstName(),
    hostName: faker.person.fullName(),
    currentTier: tiers[3].name,
    currentTierColor: tiers[3].color,
    email: {
      value: "lee.linda@email.com",
      isValid: true,
      marketingOptOut: false,
    },
    phone: {
      value: faker.phone.number(),
      isValid: true,
      marketingOptOut: false,
    },
  },
];

const mockOffers = getRandomArray(1, 100).map(() => {
  const offerCategory = getRandom(offerCategories);
  const date = getRandomDate().toISOString();
  return {
    offerId: getRandomInt(1, 1000),
    name: faker.commerce.productName(),
    status: "testing",
    category: offerCategory.name,
    categoryId: offerCategory.id,
    displayValue: "testing",
    value: 1,
    start: date,
    end: getDateAfter(date),
    redemptionDate: "testing",
    description: faker.commerce.productDescription(),
    disclaimer: "Disclaimer",
  };
});

const qualifyingFlags = ["New Club Serrano Member", "Has not had play in 12-months"];
const closedBuildUpStatuses = [
  "Closed - No Further Action",
  "Closed - Serrano Account Barred",
  "Closed - Patron Excluded",
];
const buildUpStatuses = ["Investigation Open", "Further Monitoring Needed"];

const mockBuildUpStatuses: IBuildUpStatus[] = [...closedBuildUpStatuses, ...buildUpStatuses].map((status) => ({
  incidentStatusId: getRandomInt(1, 1000),
  statusName: status,
}));

const freeOffers = getRandomArray(3, 10).map(() => {
  return {
    offerId: getRandomInt(1, 1000).toString(),
    offerName: faker.commerce.productName(),
    offerAmount: getRandomInt(1000, 10000),
  };
});

// faker.person.fullName()

const mockBuildUpPlayers: IBuildUpPlayer[] = mockPlayers.map((p) => {
  const { playerId, firstName, lastName } = p;
  return {
    playerId,
    status: getRandom(buildUpStatuses),
    statusDateTime: getRandomDate().toISOString(),
    actionByUserName: faker.datatype.boolean() ? "john.huynh@SMGHAPALMS.omnimicrosoft.com" : null,
    playerName: `${firstName} ${lastName}`,
    indicator: faker.datatype.boolean(),
    qualifyingFlag: getRandom(qualifyingFlags),
    flaggedCoinIn: getRandomInt(1, 1000),
    flaggedDate: getRandomDate().toISOString(),
    freePlayOffersToday: faker.datatype.boolean() ? freeOffers : null,
    amountOfFreePlayToday: faker.datatype.boolean() ? getRandomInt(1, 1000) : 0,
    amountOfTotalFreePlay: getRandomInt(1, 1000),
    // activity: faker.company.catchPhraseNoun(),
    // activityLocation: faker.location.city(),
    // activityTimestamp: faker.date.between({ from: "2022-07-01T00:00:00.000Z", to: moment().toString() }).toString(),
    activityType: faker.company.catchPhraseNoun(),
    locationOfActivity: faker.location.city(),
    timeofActivity: faker.date.between({ from: "2022-07-01T00:00:00.000Z", to: moment().toString() }).toString(),
  };
});

const mockFreePlayStats: IFreePlayStats = {
  amountOfFreePlayToday: getRandomInt(1, 5000),
  freePlayOffersToday: freeOffers.map((f) => ({ ...f, redeemed: faker.datatype.boolean() })),
};

const mockTopics = topicIds.map((id) => {
  return {
    id: id,
    name: faker.word.adjective(),
    parentId: getRandomInt(1, 40),
  };
});

let mockNotes = getRandomArray(10, 80).map(() => {
  const topicId = getRandom(topicIds);
  const topicName = mockTopics.find((t) => t.id === topicId)!.name;
  return {
    id: getRandomInt(0, 100),
    playerId: getRandomInt(0, 50),
    description: faker.lorem.lines(),
    createdBy: faker.person.fullName(),
    modifiedBy: faker.person.fullName(),
    createdAt: getRandomDate().toISOString(),
    modifiedAt: getRandomDate().toISOString(),
    topicId,
    topicName,
    applicationId: uuidv4(),
    canEdit: true,
    isSensitive: faker.datatype.boolean() ? faker.datatype.boolean() : null,
  };
});

const mockFolios: IPlayerFolio[] = getRandomArray(50, 150).map(() => {
  return {
    description: faker.lorem.words(),
    comment: faker.commerce.productDescription(),
    transactionAmount: parseInt(faker.commerce.price()),
    folio: getRandom(["Folio A", "Folio B", "Folio C", "Some Random Folio Name"]),
    transactionDate: faker.date
      .between({
        from: moment()
          .add(getRandomInt(1, 11) * -1, "month")
          .toISOString(),
        to: moment().toISOString(),
      })
      .toISOString()
      .split("T")[0],
  };
});

const mockMobileAppInformation = {
  devices: [
    {
      id: "1",
      platform: "Android",
      name: "Nick's S10",
      appVersion: "0.8.6",
      isActive: false,
      lastSession: new Date().toISOString(),
    },
    { id: "2", platform: "iOS", name: "Nick's IPhone 14", appVersion: "0.8.3", isActive: true, lastSession: null },
  ],
  latestSession: { deviceId: getRandomInt(1, 3), timestamp: new Date().toISOString() },
  sessions: getRandomArray(7, 7).map(() => ({
    deviceId: `${getRandomInt(1, 3)}`,
    timestamp: new Date().toISOString(),
  })),
};

const mockClubInfo = {
  email: "nicholasmata94@gmail.com",
  initialLinkDate: new Date(),
  lastLinkDate: new Date(),
};

const languages = {
  Abkhaz: "ab",
  Afar: "aa",
  Afrikaans: "af",
  Akan: "ak",
  Albanian: "sq",
  Amharic: "am",
  Arabic: "ar",
  Aragonese: "an",
  Armenian: "hy",
  Assamese: "as",
  Avaric: "av",
  Avestan: "ae",
  Aymara: "ay",
  Azerbaijani: "az",
  Bambara: "bm",
  Bashkir: "ba",
  Basque: "eu",
  Belarusian: "be",
  Bengali: "bn",
  Bihari: "bh",
  Bislama: "bi",
  Bosnian: "bs",
  Breton: "br",
  Bulgarian: "bg",
  Burmese: "my",
  "Catalan; Valencian": "ca",
  Chamorro: "ch",
  Chechen: "ce",
  "Chichewa; Chewa; Nyanja": "ny",
  Chinese: "zh",
  Chuvash: "cv",
  Cornish: "kw",
  Corsican: "co",
  Cree: "cr",
  Croatian: "hr",
  Czech: "cs",
  Danish: "da",
  "Divehi; Dhivehi; Maldivian;": "dv",
  Dutch: "nl",
  English: "en",
  Esperanto: "eo",
  Estonian: "et",
  Ewe: "ee",
  Faroese: "fo",
  Fijian: "fj",
  Finnish: "fi",
  French: "fr",
  "Fula; Fulah; Pulaar; Pular": "ff",
  Galician: "gl",
  Georgian: "ka",
  German: "de",
  "Greek, Modern": "el",
  Guaraní: "gn",
  Gujarati: "gu",
  "Haitian; Haitian Creole": "ht",
  Hausa: "ha",
  "Hebrew (modern)": "he",
  Herero: "hz",
  Hindi: "hi",
  "Hiri Motu": "ho",
  Hungarian: "hu",
  Interlingua: "ia",
  Indonesian: "id",
  Interlingue: "ie",
  Irish: "ga",
  Igbo: "ig",
  Inupiaq: "ik",
  Ido: "io",
  Icelandic: "is",
  Italian: "it",
  Inuktitut: "iu",
  Japanese: "ja",
  Javanese: "jv",
  "Kalaallisut, Greenlandic": "kl",
  Kannada: "kn",
  Kanuri: "kr",
  Kashmiri: "ks",
  Kazakh: "kk",
  Khmer: "km",
  "Kikuyu, Gikuyu": "ki",
  Kinyarwanda: "rw",
  "Kirghiz, Kyrgyz": "ky",
  Komi: "kv",
  Kongo: "kg",
  Korean: "ko",
  Kurdish: "ku",
  "Kwanyama, Kuanyama": "kj",
  Latin: "la",
  "Luxembourgish, Letzeburgesch": "lb",
  Luganda: "lg",
  "Limburgish, Limburgan, Limburger": "li",
  Lingala: "ln",
  Lao: "lo",
  Lithuanian: "lt",
  "Luba-Katanga": "lu",
  Latvian: "lv",
  Manx: "gv",
  Macedonian: "mk",
  Malagasy: "mg",
  Malay: "ms",
  Malayalam: "ml",
  Maltese: "mt",
  Māori: "mi",
  "Marathi (Marāṭhī)": "mr",
  Marshallese: "mh",
  Mongolian: "mn",
  Nauru: "na",
  "Navajo, Navaho": "nv",
  "Norwegian Bokmål": "nb",
  "North Ndebele": "nd",
  Nepali: "ne",
  Ndonga: "ng",
  "Norwegian Nynorsk": "nn",
  Norwegian: "no",
  Nuosu: "ii",
  "South Ndebele": "nr",
  Occitan: "oc",
  "Ojibwe, Ojibwa": "oj",
  "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic": "cu",
  Oromo: "om",
  Oriya: "or",
  "Ossetian, Ossetic": "os",
  "Panjabi, Punjabi": "pa",
  Pāli: "pi",
  Persian: "fa",
  Polish: "pl",
  "Pashto, Pushto": "ps",
  Portuguese: "pt",
  Quechua: "qu",
  Romansh: "rm",
  Kirundi: "rn",
  "Romanian, Moldavian, Moldovan": "ro",
  Russian: "ru",
  "Sanskrit (Saṁskṛta)": "sa",
  Sardinian: "sc",
  Sindhi: "sd",
  "Northern Sami": "se",
  Samoan: "sm",
  Sango: "sg",
  Serbian: "sr",
  "Scottish Gaelic; Gaelic": "gd",
  Shona: "sn",
  "Sinhala, Sinhalese": "si",
  Slovak: "sk",
  Slovene: "sl",
  Somali: "so",
  "Southern Sotho": "st",
  "Spanish; Castilian": "es",
  Sundanese: "su",
  Swahili: "sw",
  Swati: "ss",
  Swedish: "sv",
  Tamil: "ta",
  Telugu: "te",
  Tajik: "tg",
  Thai: "th",
  Tigrinya: "ti",
  "Tibetan Standard, Tibetan, Central": "bo",
  Turkmen: "tk",
  Tagalog: "tl",
  Tswana: "tn",
  "Tonga (Tonga Islands)": "to",
  Turkish: "tr",
  Tsonga: "ts",
  Tatar: "tt",
  Twi: "tw",
  Tahitian: "ty",
  "Uighur, Uyghur": "ug",
  Ukrainian: "uk",
  Urdu: "ur",
  Uzbek: "uz",
  Venda: "ve",
  Vietnamese: "vi",
  Volapük: "vo",
  Walloon: "wa",
  Welsh: "cy",
  Wolof: "wo",
  "Western Frisian": "fy",
  Xhosa: "xh",
  Yiddish: "yi",
  Yoruba: "yo",
  "Zhuang, Chuang": "za",
};

const mockAllLanguages = Object.keys(languages).map((language, idx) => {
  return {
    id: idx,
    name: language,
  };
});

const mockPlayerLanguage = mockAllLanguages[getRandomInt(0, mockAllLanguages.length - 1)].id;

class MockPlayerDataStore {
  get notes(): IPlayerNote[] {
    return mockNotes;
  }

  get topics(): INoteTopic[] {
    return mockTopics;
  }

  get offers(): IPlayerOffer[] {
    return mockOffers;
  }

  get folios(): IPlayerFolio[] {
    return mockFolios;
  }

  getPlayers(req: { term: string }): IPlayerSearchInfo[] {
    const { term } = req;
    if (term === undefined) {
      throw Error("Uh oh something went wrong");
    }
    if (term === "single") {
      const playerIndex = getRandomInt(0, mockPlayers.length - 1);
      return mockPlayers.filter((_, index) => index === playerIndex);
    }
    if (term === "multiple") {
      return mockPlayers;
    }
    return [];
  }

  getBasicPlayerInformation(id: string): IBasicPlayerInformation {
    const status: IPlayerStatus = { text: "Active", color: "success" };
    const existingPlayer = mockPlayers.find((player) => player.playerId === parseInt(id));
    const basicPlayer = existingPlayer ? existingPlayer : mockPlayers[0];
    return {
      ...basicPlayer,
      status,
      isMarketingSuppressed: getRandom([true, false]),
      favorited: getRandom([true, false]),
    };
  }

  getPlayerInformation(id: string): IPlayerInformation {
    return {
      currentTier: {
        name: "Classic",
        startColor: "#791818",
        endColor: "#DA4240",
        card: {
          front: "https://CDNEP-UXM-PROD-001.azureedge.net/Yaamava/ClubCard/Classic/front.jpg",
          back: "https://...",
        },
        expiration: "01/31/2023",
      },
      earningTier: {
        name: "Classic",
        startColor: "#791818",
        endColor: "#DA4240",
        card: {
          front: "https://...",
          back: "https://...",
        },
        evaluation: "12/31/2022",
        pointsToNextTier: 29526,
        nextTierName: "Emerald",
      },
      status: {
        text: "Active|Banned|In Active|...",
        color: "#000000",
      },
      birthDate: "Feb 18",
      primaryProperty: {
        name: "Yaamava",
        logo: "https://...",
      },
      balances: {
        earnedRewards: 100.0,
        tierPoints: 20474,
        slotPoints: 1000,
        compDollars: 100.0,
        walletBalance: faker.datatype.boolean() ? 100.5 : null,
      },
      sourceOfFunds: {
        jobTitle: "Rule of Galaxy",
        company: "Sith Co",
        lastUpdated: "May 4, 20222",
      },
      host: { hostId: 1, hostName: "PD P1" },
      anniversaryDate: "2022-08-29",
      languageId: mockPlayerLanguage,
    };
  }

  getNote(id: number): IPlayerNote {
    const note = mockNotes.find((n) => n.id === id);
    if (!note) throw Error("Unable to find note");
    return note;
  }

  addNote(note: ICreateNote): IPlayerNote {
    const newNote = {
      ...note,
      id: getRandomInt(100, 150),
      topicName: mockTopics.find((t) => t.id === note.topicId)!.name,
      createdBy: "Nicholas Mata",
      modifiedBy: "Nicholas Mata",
      createdAt: moment().toISOString(),
      modifiedAt: moment().toISOString(),
      canEdit: true,
      applicationId: "applicationId",
    };
    mockNotes.push(newNote);
    return newNote;
  }

  editNote(note: IEditNote): IPlayerNote {
    let editedNote: IPlayerNote | undefined;
    mockNotes = mockNotes.map((n) => {
      if (n.id === note.id) {
        editedNote = {
          ...n,
          ...note,
        };
        return editedNote;
      }
      return n;
    });
    if (!editedNote) throw new Error("Missing note");
    return editedNote;
  }

  getWinLossYears(playerId: string | number) {
    return [2023, 2022, 2021, 2019, 2018];
  }

  mockBase64EncodedString = [
    "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",
  ];
  getWinLoss(year: string | number): Blob {
    const buffer = Buffer.from(this.mockBase64EncodedString[0], "base64");
    const bufferValue = buffer.toString("ascii");
    return new Blob([bufferValue], { type: "application/pdf" });
  }

  getMobileAppInformation(id: string | number) {
    return mockMobileAppInformation;
  }

  getClubInfo(id: string | number) {
    return mockClubInfo;
  }

  getCustomerValueScore(id: string) {
    return { cvScore: getRandomInt(1, 99) };
  }

  getAllLanguages(): IPlayerLanguage[] {
    return mockAllLanguages;
  }

  updatePlayerLanguage(id: string, updateBody: IUpdatePlayerLanguage) {
    const playerInfo = this.getPlayerInformation(id);
    playerInfo.languageId = updateBody.languageId;

    return playerInfo;
  }

  getNetRevenue(id: string, period: string) {
    return mockNetRevenue(period);
  }

  getBuildUpPlayers(): IBuildUpPlayer[] {
    return mockBuildUpPlayers;
  }

  getBuildUpStatuses(): IBuildUpStatus[] {
    return mockBuildUpStatuses;
  }

  getRecentBuildUpStatus(playerId: number): ICurrentBuildUpStatus {
    const player = mockBuildUpPlayers.find((p) => p.playerId === playerId);
    if (!player) throw Error(`Unable to find player: ${playerId}`);

    const status = mockBuildUpStatuses.find((s) => s.statusName === player.status);

    if (!status) throw Error(`Unable to find status: ${player.status}`);

    const { incidentStatusId, statusName } = status;
    return {
      statusId: incidentStatusId,
      description: statusName,
      actionByUserName: player.actionByUserName,
      statusDateTime: getRandomDate().toISOString(),
    };
  }

  updateStatus({ newStatusId, playerId }: IBuildUpStatusUpdate): ICurrentBuildUpStatus {
    const recentStatus = this.getRecentBuildUpStatus(playerId);
    const newStatus = mockBuildUpStatuses.find((s) => s.incidentStatusId === newStatusId);

    if (!newStatus) throw Error(`Unable to find status: ${newStatusId}`);

    recentStatus.statusId = newStatus.incidentStatusId;
    recentStatus.description = newStatus.statusName;

    // recentStatus.actionByUserName NOTE: technically this should update too but won't mock
    return recentStatus;
  }

  getFreePlayStatus(playerId: number): IFreePlayStats {
    return mockFreePlayStats;
  }
}

export const mockPlayerDataStore = new MockPlayerDataStore();
